module.exports = __webpack_public_path__ + "static/img/main-banner.2110c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-banner.png
// module id = VCa7
// module chunks = 1